import plugin from 'tailwindcss/plugin';

export const transitionBehavior = plugin(({ addUtilities }) => {
  addUtilities({
    '.transition-discrete': { transitionBehavior: 'allow-discrete' },
    '.transition-normal': { transitionBehavior: 'normal' },
  });
});
